import React from "react";
import DatePickerField from "../Statistics/DatePickerField.jsx";
import HelpTooltip from "../HelpTooltip.jsx";
import {ZEITRAUM_PRESETS} from "./format.js";

/**
 * Zeitraum-Auswahl der Seite "Entgangener Umsatz" - Schnellwahl als
 * eigene Schaltflächen (kein natives <select>, Hausvorgabe) plus zwei
 * eigens gestaltete Datumsfelder für "Frei wählbar" (DatePickerField,
 * ebenfalls kein natives input type="date"). Jürgen soll sich den
 * Zeitraum "selbst zusammenstellen" können (Freigabe 22.09.2026) - deshalb
 * bleiben die Datumsfelder auch bei einer Voreinstellung sichtbar und
 * bearbeitbar, ein Wechsel dort springt automatisch auf "Frei wählbar".
 */
export default function ZeitraumWahl({preset, onPresetChange, von, bis, onVonChange, onBisChange, min, max}) {
    return (
        <div className="d-flex flex-wrap align-items-center gap-3">
            <div className="d-inline-flex align-items-stretch p-1 rounded-pill bg-body-secondary flex-wrap" role="group" aria-label="Zeitraum-Voreinstellung">
                {ZEITRAUM_PRESETS.map((item) => (
                    <button
                        key={item.id}
                        type="button"
                        aria-pressed={preset === item.id}
                        className={`btn btn-sm rounded-pill border-0 ${preset === item.id ? "bg-white text-body shadow-sm fw-semibold" : "text-body"}`}
                        style={{padding: ".3rem .9rem"}}
                        onClick={() => onPresetChange(item.id)}
                    >
                        {item.label}
                    </button>
                ))}
            </div>

            <div className="d-flex align-items-center gap-2">
                <DatePickerField id="eu-von" label="Von" value={von} onChange={onVonChange} min={min} max={bis || max} size="sm" style={{width: 150}} />
                <span className="text-muted small">bis</span>
                <DatePickerField id="eu-bis" label="Bis" value={bis} onChange={onBisChange} min={von || min} max={max} size="sm" style={{width: 150}} />
                <HelpTooltip placement="right">
                    Der Zeitraum bestimmt, über welche Wochen der entgangene Umsatz aufsummiert wird. Eine der
                    Schnellwahlen setzt Von/Bis automatisch; wer die Felder von Hand ändert, wechselt auf
                    „Frei wählbar".
                </HelpTooltip>
            </div>
        </div>
    );
}
